import { Activity, ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { StoreFactories } from "@com.mgmtp.a12.client/client-core/lib/core/store";

export const cancelActivityOnRemoveData = StoreFactories.createMiddleware((api, next, action) => {
	if (ActivityActions.removeData.match(action)) {
		const activities = ActivitySelectors.activities()(api.getState());
		Object.values(activities)
			.filter(
				(it): it is Activity =>
					it?.initiatingActivityId === action.payload.activityId &&
					it?.descriptor.instance === action.payload.instanceId
			)
			.forEach(it => api.dispatch(ActivityActions.cancel({ activityId: it.id })));
	}

	return next(action);
});
